export const mediaPc = () => {
    return `@media all and (max-width: 1920px)`
}
export const mediaLaptop = () => {
  return `@media all and (max-width: 1620px)`
}
 export const mediaUnderLaptop = () => {
     return `@media all and (min-width: 1279px) and (max-width: 1619px)`
 }
export const mediaMaxHeight = () => `@media all and (min-height: 850px) and (max-height: 999px)`

export const mediaMinHeight = () => `@media all and (min-height: 700px) and (max-height: 849px)`

export const mediaUnderMinHeight = () => `@media all and (max-height: 699px)`

export const mediaTablet = () => {
    return `@media all and (max-width: 1278px)`
}
export const mediaUnderTablet = () => {
  return `@media all and (max-width: 883px)`
}
 export const mediaMaxWidthMobile= () => {
     return `@media all and (max-width: 480px)`
 }
 export const mediaMobile= () => {
     return `@media all and (max-width: 360px)`
 }
 export const mediaUnderTabletQuery = "all and (max-width: 883px)";
